export const account = 'AccountSummaryDTO';
export const documentTypeClass = 'ch.fides.arsweb.data.documenthub.DocumentType';
export const documentStatusClass = 'ch.fides.arsweb.data.documenthub.DocumentStatus';
export const levelOptionClass = 'ch.fides.arsweb.domain.dto.LevelOption';

